import { Amplify } from 'aws-amplify';
import {
  AWS_USER_POOL_ID,
  AWS_USER_POOL_WEB_CLIENT_ID,
} from './environment';

export const configureAmplify = () => {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolClientId: AWS_USER_POOL_WEB_CLIENT_ID,
        userPoolId: AWS_USER_POOL_ID,
      },
    },
  });
};
